import React from 'react'
import cx from 'classnames'
import { useSelector } from 'react-redux'
import { List } from 'immutable'

import Content from './components/Content'

import './style.scss'

export default function Tabs() {
    const noTabs = useSelector((state) => state.getIn(['ui', 'tabs', 'tabs'], List()).isEmpty())

    return (
        <div className={cx('workspace-tabs', noTabs && 'hide')}>
            <Content id={'workspace-tabs'} />
        </div>
    )
}
